import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';
import {getStorageItem, setStorageItem} from '../../../services/storageService';

/**
 UserBlacklist = {
    [userName]: {
        [zoomFname]: [entityIds]
    }
 } 
*/

type UserBlacklist = {
    [key: string]: string[];
};

type Blacklist = {
    [key: string]: UserBlacklist;
};

export const BLACKLIST_KEY = 'PMoreInfoBlacklist';

const getServerBlacklist = async () => {
    try {
        const blacklist = await getStorageItem(BLACKLIST_KEY);
        const {PMoreInfoBlacklist} = blacklist;
        return PMoreInfoBlacklist ? JSON.parse(PMoreInfoBlacklist) : null;
    } catch (err) {
        console.error('An error occured while getting Personalization MoreDetails Blacklist:', err);
    }
};

export const getUserBLFromServer = async () => {
    try {
        const blacklist = await getServerBlacklist();
        const userName = getUsername();
        const userBlacklist = blacklist && blacklist[userName];
        return userBlacklist;
    } catch (err) {
        console.error(
            'An error occured while getting User Personalization MoreDetails Blacklist:',
            err
        );
    }
};

const saveBlacklist = async (data: Blacklist) => {
    try {
        await setStorageItem(BLACKLIST_KEY, JSON.stringify(data));
    } catch (err) {
        console.error('An error occured while updating Personalization Searches Blacklist', err);
    }
};

const updateBlacklist = async (
    blacklist: Blacklist,
    userName: string,
    zoomFname: string,
    entityId: string
) => {
    const blacklistCopy = {...blacklist};
    const userBlacklist = blacklistCopy[userName];

    if (!userBlacklist) {
        blacklistCopy[userName] = {[zoomFname]: [entityId]};
        saveBlacklist(blacklistCopy);
    } else {
        const entityIds = userBlacklist[zoomFname];
        if (!entityIds) {
            userBlacklist[zoomFname] = [entityId];
            await saveBlacklist(blacklistCopy);
        } else {
            const isBlacklisted = entityIds.includes(entityId);
            if (!isBlacklisted) {
                entityIds.push(entityId);
                await saveBlacklist(blacklistCopy);
            }
        }
    }
};

export const addScreenToServerBlacklist = async (zoomFname: string, entityId: string) => {
    const blacklist = await getServerBlacklist();
    const userName = getUsername();
    if (!blacklist) {
        const data = {
            [userName]: {[zoomFname]: [entityId]}
        };
        await saveBlacklist(data);
    } else {
        await updateBlacklist(blacklist, userName, zoomFname, entityId);
    }
};
